import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCreditLimitReport extends Layout {
    checkboxIncludeUnposted: Checkbox;
    checkboxPageBreak: Checkbox;
    excludabletextboxCat: ExcludableTextbox;
    excludabletextboxCollection: ExcludableTextbox;
    excludabletextboxCustomer: ExcludableTextbox;
    excludabletextboxSalePerson: ExcludableTextbox;
    sourceCreditLimit: DataSource;
    textboxGroupBy: Textbox;
    textboxPercentLimit: Textbox;
    textboxSort: Textbox;
}
